import { combineReducers } from "redux";

import modalReducer, { IModalState } from "./modal";
import generalReducer, { IGeneralState } from "./general";
import venueReducer, { IVenueReducerState } from "./venue";
import sidebarReducer, { ISidebarState } from "./sidebar";
import outstandingReducer, { IOutstandingState } from "./outstanding";
import { IMerchantAccount } from "../interfaces/IMerchantAccount";
import { merchantReducer } from "./merchant";
import { permissionsReducer } from "./permissions";
import { isEposNowReducer } from "./isEposNow";
import { IDialogHandleState, dialogReducer } from "./dialog";
import localizationReducer from "../yoello-lib/modules/redux/reducers/localization";
import Store from "../yoello-lib/modules/interfaces/store";
import { disabledRoutesReducer } from "./disabledRoutes";
import { selectedVenueIdReducer } from "./selectedVenueId";
import { IPaymentState, paymentReducer } from "./payment";
import { timezonesReducer, timezoneState } from "./timezones";
import languageReducer, { ILanguageState } from "./language";
import { DiscountsReducer, IDiscountsState } from "./Discounts.reducer";
import { subscriptionsReducer } from "./subscriptions";
import { IMigrationState, migrationReducer } from "./migration";
import { DialogRouteReducer, IDialogRouteStages } from "./DialogRoutes.reducer";
import { venueTypesReducer } from "./venueTypes";
import { feePlansReducer } from "./feePlans";
import { openBankingReducer , IOpenBankingState } from "./openBanking";
import { dialogHistoryReducer } from "./dialogHistory";

export interface IReduxAppState extends Store {
  modal: IModalState;
  venue: IVenueReducerState;
  general: IGeneralState;
  sidebar: ISidebarState;
  outstanding: IOutstandingState;
  merchant: IMerchantAccount;
  isEposNow: boolean;
  dialog: IDialogHandleState<any>;
  disabledRoutes: string[];
  selectedVenueId: string;
  payments: IPaymentState;
  timezones: timezoneState;
  language: ILanguageState;
  discounts: IDiscountsState;
  subscription: string;
  migrations: IMigrationState;
  dialogRoutes: IDialogRouteStages,
  venueTypes: any;
  feePlans: any;
  permissions: any;
  openBanking:IOpenBankingState;
  dialogHistory:any;
}

const combinedReducers = combineReducers({
  modal: modalReducer,
  venue: venueReducer,
  general: generalReducer,
  sidebar: sidebarReducer,
  outstanding: outstandingReducer,
  merchant: merchantReducer,
  isEposNow: isEposNowReducer,
  dialog: dialogReducer,
  localization: localizationReducer,
  disabledRoutes: disabledRoutesReducer,
  selectedVenueId: selectedVenueIdReducer,
  payments: paymentReducer,
  language: languageReducer,
  timezones: timezonesReducer,
  discounts: DiscountsReducer,
  subscription: subscriptionsReducer,
  migrations: migrationReducer,
  dialogRoutes: DialogRouteReducer,
  venueTypes: venueTypesReducer,
  feePlans: feePlansReducer,
  permissions: permissionsReducer,
  openBanking:openBankingReducer,
  dialogHistory: dialogHistoryReducer
});

export default combinedReducers;
